<script>
import { layoutComputed } from "@/state/helpers";

import Vertical from "./vertical";
import Horizontal from "./horizontal";
import TwoColumns from "./twocolumn";
import FloatingChatContainer from "@/components/chat/FloatingChatContainer.vue";

export default {
    components: {
        Vertical,
        Horizontal,
        TwoColumns,
        FloatingChatContainer
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },

};
</script>

<template>
<div>
    <Vertical v-if="layoutType === 'vertical'" :layout="layoutType">
        <slot />
    </Vertical>
 
    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>

    <TwoColumns v-if="layoutType === 'twocolumn'" :layout="layoutType">
        <slot />
    </TwoColumns>

    <!-- Global Floating Meta Chat Container -->
    <FloatingChatContainer />
</div>
</template>
